import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={6} lg={5} className="text-center">
          <div className="mb-4">
            <Lock size={64} className="text-danger mb-3" style={{ display: 'block', margin: '0 auto' }} />
            <h1 className="h2 fw-bold">Access Denied</h1>
            <p className="text-muted mb-4">
              You don't have permission to access this resource.
            </p>
          </div>
          <Button 
            variant="success" 
            size="lg"
            onClick={() => navigate('/')}
            className="mb-2 w-100"
          >
            Go to Home
          </Button>
          <Button 
            variant="outline-success" 
            size="lg"
            onClick={() => navigate(-1)}
            className="w-100"
          >
            Go Back
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default Unauthorized;
